var h = /* @__PURE__ */ ((r) => (r.dateFirst = "d/m/Y", r.monthFirst = "m/d/Y", r))(h || {}), i = /* @__PURE__ */ ((r) => (r.hourMinute = "H:i", r.hourMinuteAmPm = "h:i A", r.hourMinuteSecond = "H:i:s", r.hourMinuteSecondAmPm = "h:i:s A", r))(i || {});
export {
  h as DateFormatEnum,
  i as TimeFormatEnum
};
